import {api, request} from "./"

export function fetchCart(commit) {
    return request(commit, '/cart', false)
}

export function addToCart(commit, payload) {
    return request(commit, '/cart/add', payload, 'post')
}

export function removeFromCart(commit, id) {
    return request(commit, '/cart/remove', {id}, 'post')
}

export function setShipping(commit, payload) {
    return request(commit, '/shipping/set-address', payload, 'post')
}

export function fetchShippingMethods(commit) {
    return request(commit, '/shipping/methods', false)
}

export function setShippingMethod(commit, token) {
    return request(commit, '/shipping/set-method', {token}, 'post')
}

export function clearShippingMethod(commit) {
    return request(commit, '/shipping/clear-method')
}

export function getAuthStatus(commit) {
    return request(commit, '/pp/getAuth')
}

export function setAuthStatus(commit, auth) {
    return request(commit, '/pp/authorized', auth, 'post')
}

export function placeOrder(commit, auth) {
    return request(commit, '/pp/execute', auth, 'post')
}



// WEBPACK FOOTER //
// ./src/store/api/main.js